import { ColDef } from 'ag-grid-community';
import { t } from 'i18next';

import { commonColumns } from 'contacts/components/ContactGroupList';
import { IContactGroup } from 'contacts/types';
import { ChipListCell } from 'core/elements';

export const columnDef = (openDetails: (data: IContactGroup) => void): ColDef[] => {
  const { idColumn, nameColumn, contactGroupingNameColumn, websiteColumn, domainsColumn } =
    commonColumns(openDetails);

  const { supplierNumberColumn, vendorNumbersColumn, legacyVendorNumbersColumn } =
    vendorColumnDef();

  return [
    idColumn,
    nameColumn,
    contactGroupingNameColumn,
    websiteColumn,
    domainsColumn,
    supplierNumberColumn,
    vendorNumbersColumn,
    legacyVendorNumbersColumn,
  ];
};

const vendorColumnDef = () => ({
  supplierNumberColumn: {
    colId: 'alternateVendorId',
    headerName: t('headerSupplierNumber'),
    field: 'alternateVendorId',
    filter: 'agTextColumnFilter',
  },
  vendorNumbersColumn: {
    colId: 'legacySupplierNumbers',
    headerName: t('headerVendorNumbers'),
    field: 'legacySupplierNumbers',
    filter: 'agTextColumnFilter',
    cellRenderer: ChipListCell,
  },
  legacyVendorNumbersColumn: {
    colId: 'legacyVendorNumbers',
    headerName: t('headerLegacyVendorNumbers'),
    field: 'legacyVendorNumbers',
    filter: 'agTextColumnFilter',
    cellRenderer: ChipListCell,
  },
});
